<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect x="0" style="fill: #ffffff" width="200" height="200" />
    <g>
      <path
        style="fill: #4cbf8e"
        d="M78.7,135.7c-9.8,0-18.9,0-28.7,0c13.4-23.8,27.4-47.6,40.9-71.3l14,25l0,0"
      />
      <path style="fill: #3d546a" d="M104.9,89.3" />
      <path
        style="fill: #3d546a"
        d="M104.9,89.3c0,0,16.5,27.4,20.1,32.9c2.4,4.3,4.3,8.5,6.7,13.4c-17.7,0-35.4,0-53,0"
      />
      <path
        style="fill: #468c7d"
        d="M114,73.5c12.2,20.7,23.8,41.5,36,62.2c-6.1,0-12.2,0-18.3,0l-26.8-46.3L114,73.5z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconNuxt",
};
</script>
